import { BrowserStorageLocalServiceInterface } from './service.interface';
import { BrowserStorageFactory } from '../../module/browser/storage.factory';

const browserStorageLocalService = BrowserStorageFactory();

browserStorageLocalService.setStorage(window.localStorage);

export function BrowserStorageLocalService(): BrowserStorageLocalServiceInterface {
  return browserStorageLocalService;
}
